<div class="card h-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-xl font-semibold">Conséquence potentielle</h2>
    <button
      *ind4HasRole="'SED_PLUS_REGULAR_USER'"
      type="button"
      pButton
      pRipple
      icon="pi pi-pencil"
      class="p-button-sm p-button-outlined"
      pTooltip="Modifier les opérations de maintenance"
      (click)="openEditModal()"
    >
      Modifier
    </button>
  </div>

  <app-data-state [loading]="loading$ | async" [error]="error$ | async">
    <div class="p-fluid">
      <div class="flex flex-col gap-1">
        <ng-template #noData>
          <app-no-data></app-no-data>
        </ng-template>

        <div
          *ngIf="sortedPotentialConsequences?.length; else noData"
          class="flex flex-col gap-3"
        >
          <div
            *ngFor="let action of sortedPotentialConsequences"
            class="flex items-center gap-3 p-4 border border-[#e1e5e9] rounded-md bg-white"
          >
            <div
              class="w-8 h-8 flex items-center justify-center rounded-full bg-red-100 text-red-500 shrink-0"
            >
              <i-lucide
                name="octagon-x"
                class="text-red-400"
                [size]="16"
              ></i-lucide>
            </div>
            <div class="flex-1 font-medium leading-6 text-gray-700">
              {{ action?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-data-state>

  <!-- Edit Modal -->
  <app-edit-potential-consequences-modal
    [visible]="showEditModal"
    [items]="potentialConsequences ?? []"
    [ruleUid]="ruleUid ?? ''"
    (visibleChange)="showEditModal = $event"
    (onSubmitForm)="onModalSubmit($event)"
    (onCancelForm)="onModalCancel()"
  ></app-edit-potential-consequences-modal>
</div>
